module.exports = __webpack_public_path__ + "static/media/successToast.c822c133.svg";